<template>
    <div id="main-wrapper">
        <NavbarDark/>

        <section class="bg-primary position-relative">
            <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
            <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
            <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
            <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
            <div class="ht-30"></div>
            <div class="ht-30"></div>
        </section>

        <section class="gray-simple">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="item-shorting-box">
                            <div class="item-shorting clearfix">
                                <div class="left-column pull-left">
                                    <h4 class="m-0 fs-6">
                                        {{ $t('Found Result') }} {{ totalResults }} 
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center g-4">
                    <div v-if="countries.length === 0">
                        <p>{{ $t('There is no country until now!') }}</p>
                    </div>
                        <GridCountryAll :items="countries"/>
                </div>
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue';
import axios from 'axios';
import GridCountryAll from '@/components/property/grid-country-all.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n"; 
const countries = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const totalResults = ref(0);
const perPage = ref(0);
const loading = ref(false);
const observer = ref(null);
const { locale } = useI18n();

const fetchCountries = async () => {
    if (loading.value || currentPage.value > totalPages.value) return;

    loading.value = true;
    try {
        const response = await axios.get(`/countries?page=${currentPage.value}&lang=${locale.value}`);
        
        const newData = response.data.data || [];
        const meta = response.data.meta;

        if (!newData.length) {
            totalPages.value = currentPage.value - 1
            return;
        }

        if (currentPage.value === 1) {
            countries.value = newData;
        } else {
            countries.value.push(...newData);
        }

        if (meta) {
            totalResults.value = meta.total;
            perPage.value = meta.per_page;
            totalPages.value = meta.last_page;
        }

        currentPage.value++;
    } catch (error) {
        console.error("Error fetching cities:", error);
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {

    if (observer.value) observer.value.disconnect()

    observer.value = new IntersectionObserver((entries) => {

    const entry = entries[0]

    if (!entry.isIntersecting) return
    if (loading.value) return
    if (currentPage.value > totalPages.value) return

    fetchCountries()

    }, { threshold: 0.1 })

    const sentinel = document.getElementById('scroll-sentinel')
    if (sentinel) observer.value.observe(sentinel)
}


onMounted(async () => {
    await nextTick()
    fetchCountries()
    setupObserver()
})
onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
});

//SEO
import { computed } from 'vue';
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
watch(locale, async () => {

    countries.value = []
    currentPage.value = 1
    totalPages.value = 1
    totalResults.value = 0

    if (observer.value) {
        observer.value.disconnect()
        observer.value = null
    }

    await nextTick()

    await fetchCountries()
    setupObserver()

}, { immediate: true })
</script>

